const isCSSFeatureSupported = (feature) => {
    if (window.CSS && window.CSS.supports && window.CSS.supports(feature)) {
        return true;
    }
    return false;
};

export default isCSSFeatureSupported;
